<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>
<template>
  <div class="creatAutograph-box">
    <div class="shade-box">
      <div class="shade-content">
        <p class="dialog-title-bg">{{title}}签名
          <button type="button" aria-label="Close" class="el-dialog__headerbtn"   @click="resetAutographForm('creatAutographForm')"><i class="el-icon-circle-close-outline"></i></button></p>
        <div class="el-dialog__body">
          <el-form :model="creatForm" :rules="$rules" ref="creatAutographForm" label-width="100px" class="demo-ruleForm">
            <!-- <el-form-item label="签名类型" prop="signatureType">
              <el-select v-model="signatureType" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="签名内容" prop="signName">
              <el-input v-model="creatForm.signName" placeholder="请输入公司名的全称或简称" ref="signNameUnput"></el-input>
            </el-form-item>
            <el-form-item>
              <p class="colorBBB">长度为2~12个字，由中英文、数字组成，内容不包含【】。  </p>
            </el-form-item>
            <el-form-item label="资质证明" required>
              <el-upload
                class="avatar-uploader"
                ref="upload"
                action="http(s)://upload-z2.qiniup.com"
                :show-file-list="false"
                :http-request="uploadQiniu"
                :before-upload="beforeUpload"
                :limit="1"
                :auto-upload="true"
                :multiple='false'
                accept="image/jpg,image/png">
                <img v-if="picUrl" :src="picUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <p class="colorBBB">请上传 jpg、png 格式的图片，大小在5M以内</p>
            </el-form-item>
            <el-form-item label="申请说明" prop="signReason">
              <el-input type="textarea" v-model="creatForm.signReason" placeholder="请输入签名申请用途" :autosize="{ minRows: 3, maxRows: 5}" resize='none'></el-input>
            </el-form-item>
            <el-form-item class="marginTop30">
              <el-button type="primary paddingTB7" @click="submitForm('creatAutographForm')" :disabled="disabled">立即{{title}}</el-button>
              <el-button @click="resetAutographForm('creatAutographForm')">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../server/api.js'
import axios from 'axios'
export default {
  props: {
    data:{
      type: Object
    }
  },
  name: "creatAutograph",
  data(){
    return{
      disabled: false,
      title: '创建',
      picUrl: '',
      creatForm: {
        // signatureType: '',
        signName: '',
        signReason: ''
      },
    };

  },
  created(){
    if(this.data){
      this.creatForm = this.data;
      this.picUrl = this.data.signPicUrl;
      this.title = '修改';
    }else{
      this.$nextTick(function(){
        this.$refs.signNameUnput.focus();
      })
    }
  },
  methods: {
    uploadQiniu(file){
      let data = {
        "type": 7,
        "fileName": new Date().getTime() + file.file.name,
        "businessParam": 'img'
      }
      api.upImg({data:data}).then(res => {
        let formData = new FormData();
        formData.append('file',file.file);
        formData.append('token',res.token);
        formData.append('key',res.keyExtend)
        axios.post('https://up-z2.qbox.me', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(res =>{
          if(res.error){
            this.$message.error("上传失败，失败原因："+ res.error);
          }else{
            this.picUrl = 'https://img.yizl.net/' + res.data.key;
          }
        })
      })
    },
    beforeUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isLt5M;
    },
    submitForm(formName){//创建
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let _this = this;
          if(this.picUrl){
            this.disabled = true;
            if(_this.title == '创建'){
              this.add();
            }else{
              this.revise();
            }
          }else{
            this.$message.error('请先上传资质证明再创建')
          }
        } else {
          return false;
        }
      });
    },
    add(){//新增
      let data = {
        "picUrl": this.picUrl,
        "signName": this.creatForm.signName,
        "signReason": this.creatForm.signReason
      }
      api.addAutograph({data:data}).then(res => {
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.resetAutographForm('creatAutographForm')
        }else{
          this.disabled = false;
        }
      })
    },
    revise(){//修改
      let data = {
        "picUrl": this.picUrl,
        "signName": this.creatForm.signName,
        "signSign": this.creatForm.signSign,
        "signReason": this.creatForm.signReason
      }
      api.reviseAutograph({data:data}).then(res => {
        if(res.status == 'success'){
          this.$message.success(res.msg);
          this.resetAutographForm('creatAutographForm')
        }else{
          this.disabled = false;
        }
      })
    },
    resetAutographForm(formName){//取消
      this.$refs[formName].resetFields();
      this.picUrl = '';
      this.$emit('closeComponent')
    }
  },
  components: {

  }
}
</script>





// WEBPACK FOOTER //
// src/components/message/creatAutograph.vue